import React from "react";

export function Highlight({ text, highlight }) {
  if (!highlight || !text?.includes(highlight)) return <>{text}</>;
  const [a, b] = text.split(highlight);
  return <>{a}<span className="text-[var(--emerald)]">{highlight}</span>{b}</>;
}
